"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

var _Pin = _interopRequireDefault(require("@insided/destination/icons/Pin"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

var PinnedReply = function PinnedReply(_ref) {
  var id = _ref.id,
      content = _ref.content,
      userName = _ref.userName;
  var postUrl = typeof window !== 'undefined' ? "".concat(window.location.pathname, "/?postid=").concat(id, "#post").concat(id) : null;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('qa-pinned-reply-field', 'reply-flexbox', 'reply-flexbox--pinned')
  }, (0, _preact.h)("div", {
    className: "reply-header"
  }, (0, _preact.h)("div", {
    className: "reply-icon-wrapper"
  }, (0, _preact.h)(_Pin.default, {
    className: "icon--pin",
    width: 20,
    height: 20
  })), (0, _preact.h)("div", null, (0, _preact.h)("strong", {
    className: "reply-label"
  }, (0, _preact.h)(_phrase.default, {
    p: "pinned.reply.by",
    m: "Forum"
  }), " ", userName))), (0, _preact.h)(_Content.default, {
    content: content,
    className: "reply__content"
  }), postUrl && (0, _preact.h)("div", {
    className: "reply-footer"
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(postUrl),
    className: (0, _classnames.default)('link', 'link--underline', 'view-in-thread')
  }, (0, _preact.h)(_phrase.default, {
    p: "view.in.thread",
    m: "Forum"
  }))));
};

var _default = PinnedReply;
exports.default = _default;